import type { FormDate } from '../types/offerings';

/**
 * Takes an array of date objects and returns the object with
 * the earliest register date from today, with formatted dates.
 */
export const findNextDate = (dates?: FormDate[]) => {
  if (!dates || dates.length === 0) {
    return undefined;
  }

  const today = new Date().getTime();
  const nextDate = dates.find((date) => {
    const registerDate = new Date(date.registerDate).getTime();
    return registerDate > today;
  });
  if (nextDate) {
    Object.keys(nextDate).forEach((key) => {
      const formattedDate = new Date(nextDate[key as keyof FormDate]);
      formattedDate.setDate(formattedDate.getDate() + 1);
      nextDate[key as keyof FormDate] = new Date(formattedDate).toLocaleString(
        'en-US',
        {
          month: 'long',
          day: 'numeric',
        },
      );
    });
  }
  return nextDate;
};
